export default function (state = [], action) {
  switch (action.type) {
    case "SELECT_QUERIES_OF_USER":
      return action.payload;
      break;
    default:
      return state;
  }
}
